const state = {
  user: null,
  authUser: null,
  status: {
    authenticated: null,
    loading: false,
  },
  users: [],
  loginError: null,
  registrationError: null,
};

export default state;
